
export default class Newsletter {
	constructor(element) {
	  this.element = element;
	  this.init();
	}

	init() {
		var submitting_newsletters_form = false;
		var refresh = false;

		this.element.addEventListener('submit', function(e) {
			 e.preventDefault();

			 if (submitting_newsletters_form) {
				  return false;
			 }

			 submitting_newsletters_form = true;

			 var form = this;
			 var formData = new FormData(form);

			 var xhr = new XMLHttpRequest();
			 xhr.open('POST', customData.ajaxUrl, true);
			 xhr.responseType = 'json';

			 xhr.onload = function() {
				  if (xhr.status >= 200 && xhr.status < 400) {
						var data = xhr.response;
						var messageElement = form.querySelector('.message');
						messageElement.innerHTML = data.message;
						messageElement.classList.remove('is-hidden');

						if (!data.done) {
							 // Reset submit button
							 submitting_newsletters_form = false;
						}
				  }
			 };

			 xhr.send(formData);
		});
	}
 }



